import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { FleetService, Fleet, FleetVessel, AlertService, VesselShort } from '../../services'; 
import { GridApi, ColumnApi, CellValueChangedEvent, GridOptions, IGetRowsParams } from "ag-grid";
import { AgDeleteButtonComponent } from 'app/components';

declare var $:any;

@Component({
  selector: 'fleet-management',
  templateUrl: 'fleet-management.html'
})
export class FleetManagement implements OnInit {
  gridFleetApi: GridApi;
  gridFleetColumnApi: ColumnApi;

  gridVesselApi: GridApi;
  gridVesselColumnApi: ColumnApi;

  fleetList: Fleet[] = [];
  vesselList: FleetVessel[] = [];

  newFleet: Fleet = new Fleet();
  newVessel: FleetVessel = new FleetVessel();

  allVesselList: VesselShort[] = [];

  selectedFleetId: number = null;

  frameworkCompsFleet = {
    delBtnRenderer: AgDeleteButtonComponent
  };

  context;

  colDepFleet = [
    {
      headerName: 'aisFleetId',
      field: 'aisFleetId',
      filter: "agNumberColumnFilter",
      width: 90
    },
    {
      headerName: 'fleetId',
      field: 'fleetId',
      filter: "agTextColumnFilter",
      width: 90
    },
    {
      headerName: 'name',
      field: 'name',
      filter: "agTextColumnFilter",
      width: 90
    },
    {
      headerName: 'description',
      field: 'description',
      filter: "agTextColumnFilter",
      width: 90
    },
    {
      headerName: 'status',
      field: 'status',
      filter: "agTextColumnFilter",
      width: 100
    },
    {
      headerName: 'insDtm',
      field: 'insDtm',
      filter: "agTextColumnFilter",
      width: 150
    },
    {
      headerName: 'insUserId',
      field: 'insUserId',
      filter: "agNumberColumnFilter",
      width: 90
    },
    {
      headerName: 'insUser',
      field: 'insUser',
      valueGetter: params => params.data && params.data.insUser ? params.data.insUser.lastNm +  params.data.insUser.firstNm  : '',
      filter: "agTextColumnFilter",
      width: 90
    },
    {
      headerName: 'regDtm',
      field: 'regDtm',
      filter: "agTextColumnFilter",
      width: 150
    },
    {
      headerName: 'updDtm',
      field: 'updDtm',
      filter: "agTextColumnFilter",
      width: 150
    },
    {
      headerName: 'updUserId',
      field: 'updUserId',
      filter: "agNumberColumnFilter",
      width: 90
    },
    {
      headerName: 'updUser',
      field: 'updUser',
      valueGetter: params => params.data && params.data.updUser ? params.data.updUser.lastNm +  params.data.updUser.firstNm  : '',
      filter: "agTextColumnFilter",
      width: 90
    },
    {
      headerName: 'delDtm',
      field: 'delDtm',
      filter: "agTextColumnFilter",
      width: 150
    },
    {
      headerName: '삭제',
      cellRenderer: 'delBtnRenderer',  
      width: 100,

    }
  ];

  colDefVessel = [
    {
      headerName: 'aisFleetId',
      field: 'aisFleetId',
      width: 90
    },
    {
      headerName: 'mmsi',
      field: 'mmsi',
      width: 120
    },
    {
      headerName: 'imoNo',
      field: 'imoNo',
      width: 90
    },
    {
      headerName: 'vesselList',
      field: 'vesselList',
      width: 200,
      valueGetter: params => params.data && params.data.vesselList ?  params.data.vesselList.map(vessel => {return vessel.vesselNm}) : '',
    },
    {
      headerName: 'typeCd',
      field: 'typeCd',
      width: 90
    },
    {
      headerName: 'status',
      field: 'status',
      width: 100
    },
    {
      headerName: 'insDtm',
      field: 'insDtm',
      width: 150
    },
    {
      headerName: 'insUserId',
      field: 'insUserId',
      width: 90
    },
    {
      headerName: 'insUser',
      field: 'insUser',
      valueGetter: params => params.data && params.data.insUser ? params.data.insUser.lastNm +  params.data.insUser.firstNm  : '',
      width: 90
    },
    {
      headerName: 'regDtm',
      field: 'regDtm',
      width: 150
    },
    {
      headerName: 'updDtm',
      field: 'updDtm',
      width: 150
    },
    {
      headerName: 'updUserId',
      field: 'updUserId',
      width: 90
    },
    {
      headerName: 'updUser',
      field: 'updUser',
      valueGetter: params => params.data && params.data.updUser ? params.data.updUser.lastNm +  params.data.updUser.firstNm  : '',
      width: 90
    },
    {
      headerName: 'delDtm',
      field: 'delDtm',
      width: 150
    }
  ];

  constructor(
    private fleetService: FleetService,
    private alertService: AlertService,
    ) {
      this.context = { componentParent: this };
    }
  
  ngOnInit() {
    this.fleetService.getAllVesselList().subscribe(
      resp => {
        if(resp.result) {
          this.allVesselList = resp.data;
        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    )
  }

  onGridFleetReady(params) {
    this.gridFleetApi = params.api;
    this.gridFleetColumnApi = params.columnApi;

    this.getFleetList();
  }

  getFleetList() {
    this.fleetService.getFleetList().subscribe(
      resp => {
        if(resp.result) {
          this.fleetList = resp.data;
        } else {
          
        }
    });
  }

  onGridVesselReady(params) {
    this.gridVesselApi = params.api;
    this.gridVesselColumnApi = params.columnApi;
  }

  onFleetSelectionChanged(event) {
    let selectedRows = this.gridFleetApi.getSelectedRows();
    if (!selectedRows || selectedRows.length <= 0 || !selectedRows[0].aisFleetId) return;
    this.selectedFleetId = selectedRows[0].aisFleetId;

    this.getVesselList();
  }

  getVesselList() {
    this.fleetService.getVesselList(this.selectedFleetId).subscribe(
      resp => {
        this.vesselList = resp.data;
      }
    )
  }

  addFleet() {
    if(!this.newFleet.name || !this.newFleet.description) {
      this.alertService.error('Fleet 이름과 설명을 입력해주세요.');
      return;
    };

    let newFleet:Fleet[] = [new Fleet()];
    newFleet[0].name = this.newFleet.name;
    newFleet[0].description = this.newFleet.description;
    
    this.fleetService.postFleets(newFleet).subscribe(
      resp => {
        if(resp.result) {
          this.getFleetList();
          this.newFleet = new Fleet();
        }
      }
    );
  }

  selectedVessel(event: VesselShort) {
    if(!event) return;

    this.newVessel.aisFleetId = this.selectedFleetId;
    //this.newVessel.imoNo = event.imoNo;
    this.newVessel.mmsi = event.mmsi;
  }

  addVessel() {
    this.newVessel.aisFleetId = this.selectedFleetId;
    if(!this.newVessel.aisFleetId) {
      this.alertService.error('Vessel에 aisFleetId가 없습니다.');
      return;
    };

    if(!this.newVessel.mmsi) {
      this.alertService.error('Vessel에 mmsi가 없습니다.');
      return;
    }

    let newVessel:FleetVessel[] = [new FleetVessel()];
    newVessel[0].aisFleetId = this.newVessel.aisFleetId;
    //newVessel[0].imoNo = this.newVessel.imoNo;
    newVessel[0].mmsi = this.newVessel.mmsi;
    
    this.fleetService.postVessel(newVessel, this.newVessel.aisFleetId).subscribe(
      resp => {
        if(resp.result) {
          this.getVesselList();
        }
      }
    );
  }

  deleteFromParent(params) {
    $.sweetModal.confirm('Fleet을 삭제하시겠습니까?', () => {
      this.fleetService.deleteFleet(params.data.aisFleetId).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('삭제되었습니다.')
            this.getFleetList();
          } else {
            this.alertService.error(resp.errorMsg)
          }
        }
      );
    }, () => {
    });
  }

  vesselListSetValueFunc(vessel:VesselShort) {
    return vessel.vesselNm + ' (mmsi : ' + vessel.mmsi + ', imoNo : ' + vessel.imoNo + ')';
  }

  vesselListFilterFunc(vessel:VesselShort, keyword:string) {
    keyword = keyword.replace(/\s/gi, "");
    if(_.toUpper(vessel.vesselNm.trim()).replace(/\s/g, '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
    else if (_.upperCase(vessel.mmsi).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
    else if (_.upperCase(vessel.imoNo).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
    else return false;
  }
  
}


// WEBPACK FOOTER //
// ./src/app/containers/tracking/fleet-management.ts